"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeMap = void 0;
const types_1 = require("./types");
const items = [
    [types_1.PageType.ProductDetail, {
            appReg: /^litb:\/\/product\/(\d+)/,
            app2Data: (link, appReg) => {
                const result = appReg.exec(link);
                return { id: Number(result[1]) };
            },
            data2Http: (query) => {
                return `/p/${query.id}`;
            },
            data2App: (query) => {
                return `product/${query.id}`;
            },
        }]
];
exports.TypeMap = new Map(items);
